
import 'cirrus-ui'
import { IoMdConstruct } from 'react-icons/io'

export function SplashScreen(props) {
   return (
      <section className="section">
         <div className="hero fullscreen">
            <div className="hero-body">
               <div className="content">
                  <div className="text-center">
                     <h1 style={{ 'padding-top': '2em' }}>Programa de <span className='text-orange-400'>Energías Renovables</span> y No Convencionales</h1>
                     <h3 className='font-light'>Para el Desarrollo Sustentable</h3>
                     <div className="divider"></div>
                     <h3 className="font-alt font-light"><IoMdConstruct></IoMdConstruct> Sitio web en construcción...</h3>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}
